import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import styled, { keyframes } from 'react-emotion';

const ZoomPan = keyframes`
  0% {
    animation-timing-function: ease-in;
  }
  25% {
    animation-timing-function: ease-out;
    transform: scale(1.05);
    transform-origin: 16% 84%;
    translate(1.25rem, 0.9375);
  }
  50% {
    animation-timing-function: ease-in;
    transform: scale(1.125);
    transform-origin: 16% 84%;
    translate(1.25rem, 0.9375);
  }
  to {
    animation-timing-function: ease-out;
    transform: scale(1);
    translate(1.25rem, 0.9375);
  }
`;

const ZoomPanWrapStyle = styled.div`
  height: 600px;
  position: relative;
  overflow: hidden;
  .gatsby-image-wrapper {
    z-index: 0;
    height: 600px;
    img {
      animation: ${ZoomPan} 30s 2;
      animation-delay: 1400ms;
    }
  }
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    height: 500px;
    .gatsby-image-wrapper {
      height: 500px;
    }
  }
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    height: 400px;
    .gatsby-image-wrapper {
      height: 400px;
    }
  }
`;

const ZoomPanWrap = ({ children }) => {
  return(
    <ZoomPanWrapStyle>
      {children}
    </ZoomPanWrapStyle>
  );
};

export default ZoomPanWrap;

ZoomPanWrap.propTypes = {
  children: PropTypes.node,
};

/*
ZoomPan.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired
};
*/


// WEBPACK FOOTER //
// ./src/components/ZoomPanWrap.jsx